import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { FixedReportDetailPage } from './FixedReportDetailPage';
import { FixedReportFormPage } from './FixedReportFormPage';
import { FixedReportListPage } from './FixedReportListPage';

/** fixed-reports（担当: G2）。パスは `/years/:year` からの相対。S-30〜S-32 */
export const routes: RouteObject[] = [
  {
    path: 'fixed-reports',
    handle: { crumb: '定時連絡' } satisfies RouteHandle,
    element: <Outlet />,
    children: [
      { index: true, element: <FixedReportListPage /> },
      {
        path: 'new',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <FixedReportFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '新規登録' } satisfies RouteHandle,
      },
      { path: ':id', element: <FixedReportDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      {
        path: ':id/edit',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <FixedReportFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '編集' } satisfies RouteHandle,
      },
    ],
  },
];
